<template>
  <div class="page">
    <div class="page-banner">
      <div>
        <a-button v-if="token" type="link" @click="loginout">退出</a-button>
        <a-button v-else type="link">登录</a-button>
        <a-button type="link" @click="buy">预约购票</a-button>
        <a-button v-if="token" type="link" @click="order">我的订单</a-button>
      </div>
      <p><img src="../assets/images/header.png" alt="" /></p>
    </div>
  </div>
</template>
<script>
import { getAccessToken, removeAccessToken } from "../utils/cookie";

export default {
  computed: {
    token() {
      return getAccessToken();
    }
  },
  methods: {
    loginout() {
      removeAccessToken();
      location.reload();
    },
    order() {
      this.$router.push("/order");
    },
    buy() {
      this.$router.push("/");
    }
  }
};
</script>
<style scoped lang="less">
.page-banner {
  width: 1200px;
  height: 300px;
  margin: 0 auto;
  background-size: contain;
  background-repeat: no-repeat;
  background-position-x: center;
  background-image: url("../assets/images/bg.png");
  position: relative;
  div {
    width: 1200px;
    margin: 0 auto;
    padding-top: 10px;
    text-align: right;
  }
  p {
    position: absolute;
    top: 0;
    left: 0;
    img {
      height: 60px;
    }
  }
}
.page {
  width: 100%;
  height: 300px;

  background-image: url("../assets/images/header1.png");
  background-repeat: no-repeat;
  background-size: 100% 300px;
}
/deep/ .ant-btn-link {
  color: #ccc;
}
</style>
